import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MapBoxService } from 'src/app/generales/services/google-maps.service';

@Component({
  selector: 'app-mapbox',
  templateUrl: './mapbox.component.html',
  styleUrls: ['./mapbox.component.scss'],
})
export class MapboxComponent implements OnInit, OnDestroy {
  @Output() sendCoords = new EventEmitter();
  @Input() map: string = '';
  @Input() info: boolean;
  @Input() set savedCoords(value: string){
    if(value){
      this.setMap(value);
    }else{
      this.setMap();
    }
  };

  locations: any[] = [];
  coords: any;
  subscriptionPosition = new Subscription();

  constructor(
    private mapbox: MapBoxService
  ) { }

  ngOnInit() {}

  async setMap(coords?): Promise<void>{
    try{
      this.coords = await this.mapbox.getPosition();
      this.setSub();
      if(coords){
        this.coords = JSON.parse(coords);
        this.mapbox.map.setCenter(this.coords);
        this.mapbox.marker.setLngLat(this.coords);
      } 
    }catch(err){
      console.error(err);
      this.setSub();
    }
  }

  setSub(){
    this.mapbox.buildMap(this.map);
    if(!this.info){
      const mapbox = this.mapbox.emitPosition.subscribe(coords => {
        this.sendCoords.emit(coords);
      });
      this.subscriptionPosition.add(mapbox);
    }
  }

  async setSearch(ev){
    try{
      const locations: any = await this.mapbox.setSearch(ev.detail.value);
      this.locations = locations.features;
      this.locations = this.locations.map(location => {
        const fixLocation = { 
          center: location.center,
          place_name: location.place_name.replace(`${location.text},`, ''),
          text: location.text,
          id: location.id
        }
        return fixLocation;
      }, []);

    }catch(err){
      console.log(err);
    }
  }

  setLocation(location){
    this.mapbox.setCenter(location);
    this.locations = [];
    this.mapbox.marker.getLngLat();
  }

  ngOnDestroy(): void {
    console.log('destruyendo mapa');
    
    this.subscriptionPosition.unsubscribe();
  }
}
